let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gUvmO")).then(() => parcelRequire('bKKWd'));